import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { queueLength } from "./offlineQueue";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const isElectron = navigator.userAgent.toLowerCase().includes("electron");

if ("serviceWorker" in navigator && !isElectron) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(reg => {
        const checkForUpdate = () => reg.update().catch(() => {});
        window.addEventListener("online", checkForUpdate);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") checkForUpdate();
        });

        let reloaded = false;
        let reloadAttempts = 0;
        const tryReload = () => {
          if (reloaded) return;
          reloadAttempts++;
          // Don't yank the page out from under an in-progress offline sync
          // or an unsaved score entry — check back shortly instead. But
          // never wait forever: a queue entry that never clears (a stuck
          // write from an earlier bug, or one that can never succeed) would
          // otherwise block every future deploy from ever reaching this tab
          // again, silently, with no visible error — found live 2026-10-31
          // when a club account stayed on a build several versions behind
          // despite every fix actually being deployed and working. After 2
          // minutes, reload anyway; a lost unsynced write is recoverable,
          // a tab permanently stuck on stale code is not.
          if (queueLength() > 0 && reloadAttempts < 24) {
            setTimeout(tryReload, 5000);
            return;
          }
          reloaded = true;
          window.location.reload();
        };
        navigator.serviceWorker.addEventListener("controllerchange", tryReload);
      })
      .catch(err => console.log("SW registration failed:", err));
  });
}

reportWebVitals();
